module.exports = window;